import StoredLayout from '../../layouts/StoredLayout'
import UserWidgets from './UserWidgets'
export default StoredLayout(UserWidgets)



// WEBPACK FOOTER //
// ./src/widgets/user-widgets/index.js